var $6ee6c8dbb2eeacaa$exports = {};
$6ee6c8dbb2eeacaa$exports = {
    "replaceMessage": `\u{41F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{43D}\u{456}\u{442}\u{44C} \u{444}\u{430}\u{439}\u{43B} \u{434}\u{43B}\u{44F} \u{437}\u{430}\u{43C}\u{456}\u{43D}\u{438}`
};


export {$6ee6c8dbb2eeacaa$exports as default};
//# sourceMappingURL=uk-UA.mjs.map
